import { PetType } from 'constants/pet-type';
import { PET_TYPE_TOKENS_BY_REGION } from 'constants/pet-type-tokens';
import { Region } from 'constants/shop';

interface GetPetTypeFromText {
  text: string;
  region?: Region;
}

/**
 * Matches a pet type by looking for the region's pet tokens inside arbitrary text
 * (a url path, a product title, ...). Dog wins when both match, undefined when none match.
 */
export const getPetTypeFromText = ({
  text,
  region = Region.DE,
}: GetPetTypeFromText): PetType | undefined => {
  const normalizedText = text.toLowerCase();
  const petTypeTokens = PET_TYPE_TOKENS_BY_REGION[region];

  if (petTypeTokens.dog.some((token) => normalizedText.includes(token))) {
    return PetType.Dog;
  }

  if (petTypeTokens.cat.some((token) => normalizedText.includes(token))) {
    return PetType.Cat;
  }

  return undefined;
};
